import { Col, Row, Statistic } from "antd";
import React, { useEffect, useState } from "react";

import CertificatesLine from "./Dashboard/Charts/CertificatesLine";
import dashboardService from "../services/dashboard.service";

const BoardAdmin = () => {

  const [finished, setFinished] = useState(0);
  const [pending, setPending] = useState(0);
  const [cancelled, setCancelled] = useState(0);
  const [billing, setBilling] = useState(0);

  const fetchAll = async () => {
    const {finished} = await dashboardService.fetchFinished();
    const {pending} = await dashboardService.fetchPending();
    const {cancelled} = await dashboardService.fetchCancelled();
    const {total} = await dashboardService.fetchBilling();
    setFinished(finished);
    setPending(pending);
    setCancelled(cancelled);
    setBilling(total);
  }

  useEffect(()=> {
    fetchAll()
  },[])

  return (
    <div className="container">
      <header className="jumbotron">
        <h3>Certificaciones</h3>

        <CertificatesLine />

        <br />
        <br />
        <h3>Estadísticas mes</h3>

        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={6}>
            <Statistic title="Certificaciones" value={finished} />
          </Col>

          <Col span={6}>
            <Statistic title="Certificaciones pendientes" value={pending} />
          </Col>

          <Col span={6}>
            <Statistic title="Certificaciones anuladas" value={cancelled} />
          </Col>

          <Col span={6}>
            <Statistic title="Facturación" prefix='S/' value={billing} precision={2} />
          </Col>
        </Row>
      </header>
    </div>
  );
};

export default BoardAdmin;
